import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles({
    tagListItem: {
        padding: 0,
    },
});
